import type { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import { Link, type LinkProps } from "react-router";
import { twMerge } from "tailwind-merge";

import type { Require } from "@/types/Require";

export function SubtleButton({
  children,
  className,
  ...props
}: Require<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, "type">) {
  return (
    // oxlint-disable-next-line button-has-type
    <button
      className={twMerge(
        "relative isolate flex items-center justify-center rounded-full border border-transparent bg-white p-2 font-hint not-disabled:cursor-pointer hover:border-divider hover:not-disabled:bg-[hsl(from_white_h_s_98)] disabled:bg-[hsl(from_white_h_s_95)] disabled:text-placeholder",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function SubtleButtonLink({ children, className, ...props }: LinkProps) {
  return (
    <Link
      className={twMerge(
        "relative isolate flex items-center justify-center rounded-full border border-transparent bg-white px-4 py-1 font-hint not-disabled:cursor-pointer hover:border-divider hover:not-disabled:bg-[hsl(from_white_h_s_98)] disabled:bg-[hsl(from_white_h_s_95)] disabled:text-placeholder",
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
}
